import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';
import {
	notchHeight,
	Format,
	StyleColor,
	BaseStyledComponentProps,
	macTopBarHeight,
	NewStyleColor
} from '../../../utils/styles-constants';
import UserAgentUtils from '../../../utils/userAgent';
import { hexToRgba } from '../../../utils/style';

interface ButtonProps extends BaseStyledComponentProps {
	color?: string;
	disabled?: boolean;
}

const Wrapper = styled('div')`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 10;
	display: flex;
	flex-direction: column;
	background-color: ${({ theme: { primary: { backgroundColor } } }: BaseStyledComponentProps) => backgroundColor !== 'transparent' ? backgroundColor : StyleColor.White };
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.strongColor};

	${UserAgentUtils.isMacApp() && `
		padding-top: ${macTopBarHeight};
		top: -${macTopBarHeight};
	`}

	${UserAgentUtils.isIOS() && `
		@media ${Format.SmartphonePortraitNotch} {
			padding-top: ${notchHeight};
			top: -${notchHeight};
		}
	`}
`;

const Header = styled('div')`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 0 0 50px;

	${UserAgentUtils.isMacApp() && `
		padding-top: ${macTopBarHeight};
	`}

	${UserAgentUtils.isIOS() && `
		@media ${Format.SmartphonePortraitNotch} {
			padding-top: ${notchHeight};
		}
	`}
`;

const HeaderWithBorder = styled('div')`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	flex: 0 0 50px;
	padding: 0 12px;
	border-bottom: 1px solid ${hexToRgba(NewStyleColor.Grey250, 100)};

	${UserAgentUtils.isMacApp() && `padding-top: ${macTopBarHeight};`}
`;

const Button = styled('button')`
	position: absolute;
	top: 15px;
	padding: 0;
	border: 0;
	outline: 0;
	background-color: transparent;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: ${({ color, theme }: ButtonProps) => color || theme.primary.actionColor};
	letter-spacing: 0.5px;
	cursor: pointer;

	${({ disabled }: ButtonProps) => disabled && `
		opacity: 0.5;
		pointer-events: none;
	`}

	${UserAgentUtils.isMacApp() && `
		top: ${parseInt(macTopBarHeight, 10) + 15}px;
	`}

	${UserAgentUtils.isIOS() && `
		@media ${Format.SmartphonePortraitNotch} {
			top: ${parseInt(notchHeight, 10) + 15}px;
		}
	`}
`;

const ButtonCancel = styled(Button)`
	left: 20px;
`;

const ButtonConfirm = styled(Button)`
	right: 20px;
`;

const DriveListWrapper = styled('div')`
	position: relative;
	flex: 1;
	display: flex;
	overflow-x: hidden;
	overflow-y: auto;
`;

const EmptyFolderLabel = styled(Translate)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

const TitleBlack = styled(Translate)`
	margin-left: 12px;
	margin-right: auto;
	padding-right: 6px;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 600;
	font-size: 15px;
	line-height: 20px;
	color: ${NewStyleColor.Black};
`;

const ButtonClose = styled('button').attrs({
	type: 'button',
})`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 35px;
	width: 35px;
	height: 35px;
	padding: 0;
	border: 0;
	border-radius: 6px;
	outline: 0;
	background-color: ${NewStyleColor.Grey200};
	color: ${({ color }) => color || NewStyleColor.Grey200};
	cursor: pointer;
	margin-left: 12px;

	${({ disabled }) => disabled && `
		cursor: default;
		opacity: 0.5;
	`}

	svg {
		width: ${({ iconWidth }) => iconWidth};
		height: ${({ iconHeight }) => iconHeight};
		fill: currentColor;
	}
`;

export {
	Wrapper,
	Header,
	ButtonCancel,
	ButtonConfirm,
	DriveListWrapper,
	EmptyFolderLabel,
	TitleBlack,
	ButtonClose,
	HeaderWithBorder,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ResourceSelector/DrivePicker/styles.ts